import React from "react";
import PropTypes from "prop-types";

const CheckboxInput = ({
  name,
  label,
  onChange,
  checked,
  error
}) => {
  return (
      <div className="form-group">
          <div className="form-check">
            <input
                type="checkbox"
                className="form-check-input"
                id={name}
                name={name}
                defaultChecked={checked}
                onChange={onChange}
            />
            <label className="form-check-label" htmlFor={name}>{label}</label>
            {error && <div className="alert alert-danger">{error}</div>}
        </div>
    </div>
  );
};

CheckboxInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultOption: PropTypes.string,
  checked: PropTypes.bool,
  error: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object)
};

export default CheckboxInput;



// WEBPACK FOOTER //
// ./src/components/common/formfields/CheckboxInput.js